// Static demo-mode data for HolidaysSection.component.jsx.
//
// This is the demo-only branch, so the Holidays tab holds its list purely
// in local component state instead of reading/writing Firestore via
// useHolidays/companyService (see UserAttendance.demoData.js for the same
// pattern applied to a different view). Add/Edit/Delete/Import all resolve
// immediately against this array with no backend round trip.
export const DEMO_HOLIDAYS = [
  {
    date: '2026-07-04',
    name: 'Independence Day',
    optional: false,
    description: '',
  },
  {
    date: '2026-09-07',
    name: 'Labor Day',
    optional: false,
    description: '',
  },
  {
    date: '2026-10-12',
    name: 'Columbus Day',
    optional: false,
    description: '',
  },
  { date: '2026-12-25', name: 'Christmas', optional: true, description: '' },
];
